/**
 * Store web sites list
 *
 * @param commit
 */

export function storeWebSitesList(_ref, data) {
  var commit = _ref.commit;
  commit('SET_WEB_SEARCH_LIST', data);
}

/**
 * Store web selected sites
 *
 * @param commit
 * @param data
 */
export function storeWebSelectedSites(_ref2, data) {
  var commit = _ref2.commit;
  commit('SET_WEB_SELECTED_SITES', data);
}
/**
 *
 * @param commit
 */
export function clearWebSelectedSites(_ref3) {
  var commit = _ref3.commit;
  commit('CLEAR_SELECTED_SITES');
}